<template>
  <div class="child-rider-conversion">
    <CRCStepAPersonalInfo v-if="step === 1" />
    <CRCStepBSelectionOptions v-if="step === 2" />
    <CRCStepCConfirmPayment v-if="step === 3" />
    <CRCStepDEDelivery v-if="step === 4" />
    <CRCStepEAcknowledge v-if="step === 5" />
    <CRCStepFSuccess v-if="step === 6" />
  </div>
</template>
<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { mapState } from 'pinia';
import { useChildRiderStore } from '../store/childrider.store';
import CRCStepFSuccess from './CRCStepFSuccess/CRCStepFSuccess.vue';
import CRCStepEAcknowledge from './CRCStepEAcknowledge/CRCStepEAcknowledge.vue';
import CRCStepDEDelivery from './CRCStepDEDelivery/CRCStepDEDelivery.vue';
import CRCStepCConfirmPayment from './CRCStepCConfirmPayment/CRCStepCConfirmPayment.vue';
import CRCStepBSelectionOptions from './CRCStepBSelectionOptions/CRCStepBSelectionOptions.vue';
import CRCStepAPersonalInfo from './CRCStepAPersonalInfo/CRCStepAPersonalInfo.vue';
import { RouteNames } from '@/router/routeNames';

const componentOptions: ComponentOptions = {
  name: 'ChildRiderSteps',
  components: {
    CRCStepAPersonalInfo,
    CRCStepBSelectionOptions,
    CRCStepCConfirmPayment,
    CRCStepDEDelivery,
    CRCStepEAcknowledge,
    CRCStepFSuccess,
  },
  computed: {
    ...mapState(useChildRiderStore, {
      step: 'step',
    }),
  },
  mounted() {
    if (this.step === undefined || this.step < 0) {
      this.$router.push({ name: RouteNames.DASHBOARD });
    }
  },
};

export default defineComponent(componentOptions);
</script>
